<div class="privacy-policy-container">
  <div class="privacy-policy-content">
    <h1>Informativa sulla privacy</h1>
    <p class="text-color-secondary">{{ softwareName }}</p>
    <p><em>Ultimo aggiornamento: 21/08/2026</em></p>

    <h3>Titolare del trattamento</h3>
    <p>
      <strong>Zetra S.r.l.</strong>, con sede legale in Roma (RM), Via Cardinale di York, 2, P.IVA
      17011451006 ("il Titolare"), è il titolare del trattamento dei dati personali raccolti tramite
      il gestionale {{ softwareName }} e la relativa app mobile
      {{ softwareName }} (l'"Applicazione").
    </p>
    <p>
      Per qualsiasi richiesta relativa al trattamento dei dati personali è possibile contattare il
      Titolare all'indirizzo: <a href="mailto:info@zetra.it">info@zetra.it</a>, oppure visitare
      <a
        href="https://www.zetra.it"
        target="_blank"
        rel="noopener"
        >www.zetra.it</a
      >.
    </p>

    <h3>A chi è destinata l'Applicazione</h3>
    <p>
      L'Applicazione è uno strumento aziendale destinato esclusivamente al personale tecnico e agli
      operatori autorizzati dal Titolare (o dai suoi clienti) per la gestione di magazzino,
      commesse, ordini e ticket di assistenza tecnica.
      <strong>Non è un'applicazione destinata al pubblico generico né ai minori di 18 anni.</strong>
      L'accesso richiede credenziali fornite dall'azienda e, per l'app mobile, un codice di licenza
      attivo.
    </p>

    <h3>Dati personali raccolti</h3>
    <p>L'Applicazione raccoglie ed elabora le seguenti categorie di dati personali:</p>
    <ul>
      <li>
        <strong>Credenziali di accesso</strong> — username e password dell'operatore, utilizzate per
        autenticarsi presso il sistema gestionale. Le credenziali vengono trasmesse in modo cifrato
        (HTTPS) e non vengono conservate in chiaro sul dispositivo.
      </li>
      <li>
        <strong>Dati identificativi dell'operatore</strong> — nome, cognome ed email dell'operatore
        autenticato, usati per personalizzare l'esperienza d'uso e attribuire le attività svolte
        (es. rapportini firmati) all'operatore corretto.
      </li>
      <li>
        <strong>Dati di localizzazione approssimativa</strong> — l'app mobile utilizza il permesso
        di localizzazione del dispositivo esclusivamente per calcolare le coordinate geografiche
        corrispondenti all'indirizzo del cliente finale associato a un ticket, al fine di mostrarlo
        su una mappa.
        <strong>Non viene mai rilevata né trasmessa la posizione GPS reale del dispositivo</strong>,
        né viene effettuato alcun tracciamento in background.
      </li>
      <li>
        <strong>Firme grafiche</strong> — la firma raccolta a schermo dal cliente finale al termine
        di un intervento tecnico, utilizzata per generare il rapportino di intervento in formato
        PDF.
      </li>
      <li>
        <strong>Fotografie</strong> — su richiesta esplicita dell'operatore (app mobile), tramite la
        fotocamera del dispositivo, per allegare una foto a un ticket. La foto viene caricata come
        allegato del ticket e non viene salvata nella libreria foto del dispositivo.
      </li>
      <li>
        <strong>File e documenti</strong> — documenti selezionati dall'operatore dal proprio
        dispositivo e allegati a un ticket, inclusi i rapportini PDF generati e firmati; è inoltre
        possibile consultare e scaricare allegati già presenti su un ticket.
      </li>
      <li>
        <strong>Dati di licenza applicativa</strong> (solo app mobile) — un codice di licenza
        fornito dal Titolare, verificato all'attivazione e conservato in modo cifrato sul
        dispositivo tramite lo storage sicuro del sistema operativo.
      </li>
      <li>
        <strong>Dati tecnici</strong> strettamente necessari al funzionamento (es. tipo di browser o
        sistema operativo, versione dell'applicazione).
      </li>
    </ul>
    <p>
      <strong>L'Applicazione non raccoglie</strong>: contatti della rubrica, cronologia
      SMS/chiamate, registrazioni audio, dati sanitari, dati finanziari, identificativi
      pubblicitari, né dati a fini di profilazione commerciale. L'Applicazione non integra strumenti
      di analytics o pubblicità di terze parti.
    </p>

    <h3>Autenticazione biometrica locale (app mobile)</h3>
    <p>
      L'app mobile può offrire, se supportato dal dispositivo, l'accesso rapido tramite impronta
      digitale o riconoscimento facciale. Questa funzione è gestita interamente dal sistema
      operativo del dispositivo: l'Applicazione non ha accesso ai dati biometrici, non li raccoglie
      e non li trasmette in alcun modo al Titolare o a terzi.
    </p>

    <h3>Finalità e base giuridica del trattamento</h3>
    <ul>
      <li>
        Autenticazione e gestione dell'accesso sicuro all'Applicazione (base giuridica: esecuzione
        del rapporto di lavoro/incarico con l'operatore);
      </li>
      <li>
        Erogazione del servizio di gestione di magazzino, commesse, ordini e ticket di assistenza
        tecnica, inclusa la localizzazione approssimativa del cliente e la generazione/trasmissione
        dei rapportini firmati (base giuridica: esecuzione del contratto tra il Titolare e i propri
        clienti, e legittimo interesse organizzativo);
      </li>
      <li>
        Attivazione e verifica della licenza dell'app mobile (base giuridica: legittimo interesse
        del Titolare a prevenire un uso non autorizzato del software).
      </li>
    </ul>

    <h3>Destinatari e trasferimento dei dati</h3>
    <p>I dati raccolti vengono trasmessi a:</p>
    <ul>
      <li>Il sistema gestionale aziendale {{ softwareName }} (backend interno del Titolare);</li>
      <li>
        Google Maps Platform / Google Play Services (Google LLC), limitatamente ai dati tecnici
        necessari per la visualizzazione della mappa e per la distribuzione dell'app mobile, secondo
        l'informativa privacy di Google (<a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener"
          >policies.google.com/privacy</a
        >);
      </li>
      <li>Il servizio interno di attivazione licenze del Titolare.</li>
    </ul>
    <p>
      Il Titolare non vende né cede a terzi, per finalità commerciali o pubblicitarie, i dati
      personali raccolti.
    </p>

    <h3>Conservazione dei dati</h3>
    <p>
      I dati sono conservati per il tempo necessario a fornire il servizio e in conformità agli
      obblighi contrattuali e di legge applicabili. La conservazione è prevista fino ai 30 giorni
      successivi alla scadenza della licenza d'uso del software.
    </p>

    <h3>Diritti dell'interessato</h3>
    <p>
      In conformità al Regolamento (UE) 2016/679 (GDPR), l'interessato ha diritto di richiedere in
      qualsiasi momento: accesso ai propri dati, rettifica, cancellazione, limitazione del
      trattamento, portabilità dei dati, opposizione al trattamento, nonché di presentare reclamo
      all'Autorità Garante per la protezione dei dati personali. Le richieste possono essere inviate
      a: <a href="mailto:info@zetra.it">info@zetra.it</a>.
    </p>

    <h3>Sicurezza</h3>
    <p>
      Il Titolare adotta misure tecniche e organizzative adeguate a proteggere i dati personali
      trattati, tra cui la trasmissione cifrata (HTTPS/TLS) di tutte le comunicazioni e la
      conservazione cifrata sul dispositivo mobile dei dati di licenza tramite lo storage sicuro del
      sistema operativo.
    </p>

    <h3>Modifiche alla presente informativa</h3>
    <p>
      Il Titolare si riserva il diritto di modificare la presente informativa in qualsiasi momento;
      le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo
      aggiornamento.
    </p>

    <h3>Contatti</h3>
    <p>
      Per qualsiasi domanda relativa alla presente informativa privacy:
      <a href="mailto:info@zetra.it">info@zetra.it</a>.
    </p>
  </div>
</div>
